import { render } from "./DealTypeBadge.vue?vue&type=template&id=78ee9c7a&scoped=true"
import script from "./DealTypeBadge.vue?vue&type=script&lang=js"
export * from "./DealTypeBadge.vue?vue&type=script&lang=js"

import "./DealTypeBadge.vue?vue&type=style&index=0&id=78ee9c7a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ee9c7a"]])

export default __exports__